import { DropDownInput } from 'components/uikit/inputs/dropdown/DropDownInput';
import { CustomModal } from 'components/uikit/modal/CustomModal';
import React, { useState } from 'react';
import { QueryFactory } from 'services/api';
import { Button, ButtonColor } from 'components/uikit/buttons/Button';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import { Field } from 'components/uikit/Field';

import styles from './ProjectCopyDropdownModal.module.scss';
import dropdownStyles from 'components/uikit/DropdownSelector.module.scss';
import { Loading } from 'components/uikit/suspense/Loading';

export type ProjectCopyDropdownModalProps = {
  onClose: () => void;
  onCopy: (projectId: number) => Promise<boolean>;
  isOpen: boolean;
  currentProjectId?: number;
};

export const ProjectCopyDropdownModal: React.FC<
  ProjectCopyDropdownModalProps
> = (props) => {
  const i18n = useScopedTranslation(
    'Page.Projects.ProjectDetailsPage.FoldersTree',
  );
  const buttonTitle = useScopedTranslation('Button.Title');
  const projectQuery = QueryFactory.ProjectQuery.useSearchQuery(
    {},
    { enabled: props.isOpen },
  );

  const [selectedProject, setSelectedProject] = useState(
    projectQuery.data?.data[0],
  );
  const [isLoading, setIsLoading] = useState(false);

  return (
    <CustomModal
      onClose={() => props.onClose()}
      isOpen={props.isOpen}
      isBlocking={true}
      title={i18n.t('copy_revision_title')}
    >
      <Loading loading={isLoading}>
        <Field title={i18n.t('projects_list')} className={styles.field}>
          <DropDownInput
            className={dropdownStyles.selectorBlack}
            classes={dropdownClasses}
            options={
              projectQuery.data?.data.filter(
                (project) => project.id != props.currentProjectId,
              ) ?? []
            }
            getOptionLabel={(project) => project.name}
            onValueChanged={(project) => {
              setSelectedProject(project!);
            }}
            value={selectedProject}
            enableSearch={true}
          />
        </Field>
        <div className={styles.footer}>
          <Button
            className={styles.button}
            color={ButtonColor.Secondary}
            title={buttonTitle.t('cancel')}
            onClick={() => {
              props.onClose();
            }}
          />
          <Button
            testId="copy"
            className={styles.button}
            color={ButtonColor.Default}
            type={'submit'}
            title={buttonTitle.t('copy')}
            onClick={async () => {
              setIsLoading(true);
              const copied = selectedProject
                ? await props.onCopy(selectedProject.id)
                : null;
              setIsLoading(false);

              if (copied) props.onClose();
            }}
          />
        </div>
      </Loading>
    </CustomModal>
  );
};

const dropdownClasses = {
  option: dropdownStyles.selectorOption,
  paper: dropdownStyles.selectorPaper,
  popper: dropdownStyles.selectorPopper,
};
